function setWatchTime() {
    var now   = moment(),
        then  = moment('2019-04-27 10:00:00', 'YYYY-MM-DD HH:mm:ss'),
        // setting countdown time to 10am for hours field //
        tmrw  = moment().hour(24).minute(00).second(00).add(10, 'hours'),
        // tmrw  = moment().hour(23).minute(59).second(59),
        nhr   = now.clone().add(1, 'hours').minute(0).second(0),
        days  = then.diff(now, 'days'),
        hours = tmrw.diff(now, 'hours'),
        mins  = nhr.diff(now, 'minutes');

    var watchDay = document.getElementById('watch-day');
    if (watchDay) {
    	watchDay.innerHTML  = days;
    }
    var watchHour = document.getElementById('watch-hour');
    if (watchHour) {
    	watchHour.innerHTML = hours;
  	}
    var watchMin = document.getElementById('watch-min');
    if (watchMin) {
	    watchMin.innerHTML  = mins;
	  }
}
// setWatchTime();
// setInterval(setWatchTime, 60000);


$('.wtd-tabs-header button').click(function() {
    var $btn = $(this),
        target = $btn.attr('data-show'),
        $tab = $(target);

    $('.wtd-tabs-header button, .wtd-tab').removeClass('active');
    $btn.addClass('active');
    $tab.addClass('active');
});
